module.exports = __webpack_public_path__ + "img/logo.eba21cb1.png";